import { parseColor } from "react-stately";

export function getCssColor(color?: string | null): string {
  if (!color) {
    return "#B6BABF";
  }

  if (color.startsWith("0x")) {
    return `#${color.slice(2)}`;
  }

  if (color.startsWith("rgb")) {
    const newColor = parseColor(color).toString("hex");
    return newColor;
  }

  return color;
}
